module.exports = __webpack_public_path__ + "img/bars.158afde3.png";